export const enum TabsOrentations {
  Vertical,
  Horizontal,
}